<template>
  <div>
    <div
      ref="refTrigger"
      :style="{ width: `${width}px` , direction }"
      class="text-truncate"
      :class="[link && 'custom-link']"
    >
      <b-link
        v-if="to"
        :to="to"
        class="text-nowrap custom-link"
      >
        {{ textString }}
      </b-link>
      <template v-else>
        {{ textString }}
      </template>
    </div>
    <b-tooltip
      v-if="render"
      placement="bottom"
      :target="refTrigger"
      :title="textString"
      :no-fade="true"
      custom-class="truncate-tooltip"
      :delay="{ show: 1000, hide: 300 } "
    >
      {{ textString }}
    </b-tooltip>
  </div>
</template>

<script>
import { BTooltip, BLink } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  name: 'TruncateTextCell',
  components: {
    BTooltip,
    BLink,
  },
  props: {
    text: {
      type: [String, Object],
      required: true,
    },
    link: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
    },
    textSubKey: {
      type: String,
    },
    width: {
      type: Number,
      default: 100,
    },
    direction: {
      type: String,
      default: 'rtl',
    },
  },
  setup() {
    const refTrigger = ref(null)
    return {
      refTrigger,
    }
  },
  computed: {
    textString() {
      return this.textSubKey ? this.text[this.textSubKey] : this.text
    },
    render() {
      return this.refTrigger && this.textString && this.textString.length > 20
    },
  },
}
</script>
<style lang="scss">
// .truncate-tooltip {
//   .tooltip-inner {
//     color: #f7f9f3;
//     background-color: #413f3f;
//     min-width: 400px;
//     font-size: 1rem;
//     line-height: 1.8;
//     text-align: justify;
//     padding: 1rem 1.5rem;
//     box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
//   }
//   .arrow {
//     visibility: hidden;
//   }
// }
.custom-link {
  color: #2828ab;
  min-height: 50px;
  line-height: 50px;
  font-weight: bold;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.01);
  }
}
</style>
